import { COUPON_COLORS } from '@/styles/coupon';
import { SxProps, Theme } from '@mui/material';

// Sin radio, como las tarjetas de producto del grid del listado.
export const containerCouponCardSX: SxProps<Theme> = {
	flex: 1,
	display: 'flex',
	position: 'relative',
	overflow: 'hidden',
	containerType: 'inline-size',
	backgroundColor: 'primary.main',
	color: 'primary.contrastText',
};

export const watermarkCouponCardSX: SxProps<Theme> = {
	position: 'absolute',
	right: '-12cqi',
	bottom: '40px',
	fontSize: '120cqi',
	fontWeight: 800,
	lineHeight: 1,
	color: '#FFFFFF12',
	pointerEvents: 'none',
	userSelect: 'none',
};

export const ticketCouponCardSX: SxProps<Theme> = {
	flex: 1,
	position: 'relative',
	zIndex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	textAlign: 'center',
	border: '2px dashed #FFFFFF8C',
	borderRadius: 'clamp(8px, 4cqi, 14px)',
	margin: 'clamp(8px, 6cqi, 22px)',
	padding: 'clamp(12px, 7cqi, 26px) clamp(8px, 6cqi, 22px) clamp(8px, 6cqi, 22px)',
};

export const eyebrowCouponCardSX: SxProps<Theme> = {
	fontSize: 'clamp(10px, 4.2cqi, 15px)',
	fontWeight: 700,
	letterSpacing: '0.15em',
	textTransform: 'uppercase',
};

export const offerCouponCardSX: SxProps<Theme> = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	paddingY: 'clamp(8px, 4.5cqi, 16px)',
};

export const discountCouponCardSX: SxProps<Theme> = {
	fontWeight: 800,
	lineHeight: 0.85,
	fontSize: 'clamp(40px, 32cqi, 140px)',
	letterSpacing: '-0.04em',
	whiteSpace: 'nowrap',
};

export const offCouponCardSX: SxProps<Theme> = {
	mt: 'clamp(4px, 1.7cqi, 6px)',
	fontWeight: 800,
	lineHeight: 1,
	fontSize: 'clamp(18px, 13cqi, 65px)',
	letterSpacing: '0.1em',
};

export const descriptionCouponCardSX: SxProps<Theme> = {
	mt: 'clamp(6px, 3.4cqi, 12px)',
	fontSize: 'clamp(11px, 5cqi, 18px)',
	color: COUPON_COLORS.border,
};

export const expirationCouponCardSX: SxProps<Theme> = {
	mb: 'clamp(10px, 5cqi, 18px)',
	padding: 'clamp(4px, 2cqi, 7px) clamp(8px, 4.5cqi, 16px)',
	borderRadius: '999px',
	backgroundColor: '#FFF',
	color: 'text.alert',
	fontWeight: 800,
	letterSpacing: '0.03em',
	whiteSpace: 'nowrap',
	fontSize: 'clamp(10px, 3.8cqi, 14px)',
	'@container (max-width: 299.95px)': {
		'& > span': {
			display: 'none',
		},
	},
};

export const buttonCouponCardSX: SxProps<Theme> = {
	width: '100%',
	minWidth: 0,
	padding: 'clamp(9px, 4.5cqi, 16px) clamp(6px, 2.5cqi, 16px)',
	fontWeight: 700,
	letterSpacing: '0.06em',
	fontSize: 'clamp(11px, 4.5cqi, 16px)',
};
